module.exports = __webpack_public_path__ + "img/resource-tech-image-22.b6d7396d.jpg";